/**
 * @generated SignedSource<<2edab510b3a17fe1264c275ebbcc6c78>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type BookingWriteAccess = "FULL_WRITE" | "JOIN" | "NONE" | "NON_OWNER_WRITE";
export type JoinBookingModalInnerQuery$variables = {
  slotId: string;
};
export type JoinBookingModalInnerQuery$data = {
  readonly node: {
    readonly agenda?: {
      readonly facility: {
        readonly club: {
          readonly supportsPrivate: boolean;
        } | null | undefined;
        readonly privateBookingPermissionSet: {
          readonly canBookOnBusySlot: boolean | null | undefined;
        } | null | undefined;
        readonly publicBookingPermissionSet: {
          readonly canBookOnBusySlot: boolean | null | undefined;
        } | null | undefined;
      };
    };
    readonly bookings?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly rounds: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly player: {
                  readonly firstName: string | null | undefined;
                  readonly id: string;
                } | null | undefined;
              } | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
          readonly writeAccess: BookingWriteAccess | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly id?: string;
  } | null | undefined;
};
export type JoinBookingModalInnerQuery = {
  response: JoinBookingModalInnerQuery$data;
  variables: JoinBookingModalInnerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slotId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "slotId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "supportsPrivate",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canBookOnBusySlot",
  "storageKey": null
},
v4 = [
  (v3/*: any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "writeAccess",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v9 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Agenda",
    "kind": "LinkedField",
    "name": "agenda",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Facility",
        "kind": "LinkedField",
        "name": "facility",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Club",
            "kind": "LinkedField",
            "name": "club",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PrivateBookingPermissionSet",
            "kind": "LinkedField",
            "name": "privateBookingPermissionSet",
            "plural": false,
            "selections": (v4/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PublicBookingPermissionSet",
            "kind": "LinkedField",
            "name": "publicBookingPermissionSet",
            "plural": false,
            "selections": (v4/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  (v5/*: any*/),
  {
    "alias": null,
    "args": (v6/*: any*/),
    "concreteType": "BookingConnection",
    "kind": "LinkedField",
    "name": "bookings",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "BookingEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "RoundConnection",
                "kind": "LinkedField",
                "name": "rounds",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoundEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "player",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              (v8/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": "bookings(first:1000)"
  }
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v11 = [
  (v3/*: any*/),
  (v5/*: any*/)
],
v12 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Agenda",
    "kind": "LinkedField",
    "name": "agenda",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Facility",
        "kind": "LinkedField",
        "name": "facility",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Club",
            "kind": "LinkedField",
            "name": "club",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PrivateBookingPermissionSet",
            "kind": "LinkedField",
            "name": "privateBookingPermissionSet",
            "plural": false,
            "selections": (v11/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PublicBookingPermissionSet",
            "kind": "LinkedField",
            "name": "publicBookingPermissionSet",
            "plural": false,
            "selections": (v11/*: any*/),
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      },
      (v5/*: any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": (v6/*: any*/),
    "concreteType": "BookingConnection",
    "kind": "LinkedField",
    "name": "bookings",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "BookingEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v10/*: any*/),
              (v7/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "RoundConnection",
                "kind": "LinkedField",
                "name": "rounds",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoundEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "player",
                            "plural": false,
                            "selections": [
                              (v10/*: any*/),
                              (v5/*: any*/),
                              (v8/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": "bookings(first:1000)"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "JoinBookingModalInnerQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": (v9/*: any*/),
            "type": "QueueSlot",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": (v9/*: any*/),
            "type": "TimeSlot",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "JoinBookingModalInnerQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          (v5/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": (v12/*: any*/),
            "type": "QueueSlot",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": (v12/*: any*/),
            "type": "TimeSlot",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8d832ea96718299fb061571b675b5028",
    "id": null,
    "metadata": {},
    "name": "JoinBookingModalInnerQuery",
    "operationKind": "query",
    "text": "query JoinBookingModalInnerQuery(\n  $slotId: ID!\n) {\n  node(id: $slotId) {\n    __typename\n    ... on QueueSlot {\n      agenda {\n        facility {\n          club {\n            supportsPrivate\n            id\n          }\n          privateBookingPermissionSet {\n            canBookOnBusySlot\n            id\n          }\n          publicBookingPermissionSet {\n            canBookOnBusySlot\n            id\n          }\n          id\n        }\n        id\n      }\n      id\n      bookings(first: 1000) {\n        edges {\n          node {\n            __typename\n            writeAccess\n            id\n            rounds {\n              edges {\n                node {\n                  __typename\n                  player {\n                    __typename\n                    id\n                    firstName\n                  }\n                  id\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    ... on TimeSlot {\n      agenda {\n        facility {\n          club {\n            supportsPrivate\n            id\n          }\n          privateBookingPermissionSet {\n            canBookOnBusySlot\n            id\n          }\n          publicBookingPermissionSet {\n            canBookOnBusySlot\n            id\n          }\n          id\n        }\n        id\n      }\n      id\n      bookings(first: 1000) {\n        edges {\n          node {\n            __typename\n            writeAccess\n            id\n            rounds {\n              edges {\n                node {\n                  __typename\n                  player {\n                    __typename\n                    id\n                    firstName\n                  }\n                  id\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "e75768db3fc22bf79866e08e37cddcb6";

export default node;
